/* Gallery mega menu: category tabs + image preview */
(function () {
  function init(panel) {
    if (panel.__luxe) return;
    panel.__luxe = true;

    var card = panel.querySelector('[data-luxe-card]');
    var img = card && card.querySelector('[data-luxe-card-img]');
    var title = card && card.querySelector('[data-luxe-card-title]');
    var defSrc = img ? img.getAttribute('src') : '';
    var defHref = card ? card.getAttribute('href') : '';
    var defTitle = title ? title.dataset.default : '';
    var timer = null;
    var cache = {};

    function show(src, text, href) {
      if (!img) return;
      if (title && text) title.textContent = text;
      if (href) card.setAttribute('href', href);
      if (!src || img.getAttribute('src') === src) return;
      clearTimeout(timer);
      var pre = cache[src] || (cache[src] = new Image());
      pre.src = src;
      img.classList.add('is-swapping');
      timer = setTimeout(function () {
        var done = function () {
          img.setAttribute('src', src);
          img.removeAttribute('srcset');
          requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
        };
        if (pre.complete) done(); else { pre.onload = done; pre.onerror = done; }
      }, 160);
    }
    function preview(a) {
      if (!a.dataset.luxeImg) return;
      show(a.dataset.luxeImg, a.dataset.luxeTitle || a.textContent.trim(), a.getAttribute('href'));
    }

    // Category tabs
    var tabs = panel.querySelectorAll('[data-luxe-tab]');
    var panes = panel.querySelectorAll('[data-luxe-pane]');
    var tabTimer = null;
    function activate(tab) {
      var id = tab.dataset.luxeTab;
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p) { p.classList.toggle('is-active', p.dataset.luxePane === id); });
      preview(tab);
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        clearTimeout(tabTimer);
        tabTimer = setTimeout(function () { activate(tab); }, 90); // small intent delay = no flicker
      });
      tab.addEventListener('focus', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var next = list[(i + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length];
          next.focus();
        }
      });
    });

    // Row hover → image
    panel.querySelectorAll('.m-mega-luxe__row').forEach(function (a) {
      a.addEventListener('mouseenter', function () { preview(a); });
      a.addEventListener('focus', function () { preview(a); });
    });

    // Reset when the menu closes; preload images on first open
    var item = panel.closest('.m-menu__item');
    if (item) {
      item.addEventListener('mouseleave', function () {
        setTimeout(function () {
          if (item.classList.contains('m-menu__item--active')) return;
          if (tabs[0]) activate(tabs[0]);
          show(defSrc, defTitle, defHref);
        }, 450);
      });
      item.addEventListener('mouseenter', function once() {
        panel.querySelectorAll('[data-luxe-img]').forEach(function (a) {
          var i = cache[a.dataset.luxeImg] || (cache[a.dataset.luxeImg] = new Image());
          i.src = a.dataset.luxeImg;
        });
        item.removeEventListener('mouseenter', once);
      });
    }
  }
  function run() { document.querySelectorAll('[data-luxe-panel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
